import { PortfolioLoading } from '@/components/assets/PortfolioLoading';
import { PortfolioEmptyState } from '@/components/assets/PortfolioEmptyState';
import { PortfolioProps } from '@/components/assets/types/asset.types';
import { useSession } from '@/contexts/LitSessionProvider';
import useERC20Balance from '@/hooks/portfolio/useERC20Balance';
import { useState } from 'react';
import Loading from '@/components/shared/Loading';
import { useLocalStorage } from 'usehooks-ts';
import { DTPortfolioHeader } from './DTPortfolioHeader';
import { DTPortfolioAssetsList } from './DTPortfolioAssetsList';
import { ScrollArea } from '@/components/ui/scroll-area';
import DesktopHistory from '@/components/home/mobile/History/Desktop/DekstopHistory';
import Image from 'next/image';
export default function DTPortfolioAssets({
  showBreakDown,
  isSwap
}: PortfolioProps) {
  const {
    PKP
  } = useSession();
  const [linkClickedLoading, setLinkClickedLoading] = useState(false);
  const [selectedTap, setSelectedTap] = useState('holdings');
  const {
    data: assetData,
    isLoading: assetDataIsLoading
  } = useERC20Balance({
    evmAddresses: [PKP?.additionalEthAddress],
    solanaAddresses: [PKP?.solanaAddress],
    useGeniusAPI: true
  });
  const [selectedNetwork, setSelectedNetwork] = useState({
    name: 'All Networks',
    value: `$${assetData?.totalUsdValue?.toLocaleString()}`,
    logo: '/static/genius.png'
  });
  const filteredBalances = selectedNetwork.name === 'All Networks' ? assetData?.balances : assetData?.balancesByChain?.find(chain => chain.networkName === selectedNetwork.name)?.balances || [];
  return <>
      <DTPortfolioHeader assetData={assetData} selectedNetwork={selectedNetwork} setSelectedNetwork={setSelectedNetwork} selectedTap={selectedTap} setSelectedTap={setSelectedTap} data-sentry-element="DTPortfolioHeader" data-sentry-source-file="DTPortfolioAssets.tsx" />
      <div className='border-genius-blue border-[1px] rounded-b-[20px] h-[524px] overflow-hidden bg-genius-indigo'>
        {assetData && assetData?.balances?.length > 0 ? <div className={`w-full text-genius-cream bg-genius-indigo pb-[500px] ${showBreakDown ? '' : '-mb-[14vh]'} relative`}>
            {assetDataIsLoading ? <PortfolioLoading /> : linkClickedLoading ? <div className='mt-[20%]'>
                <Loading />
              </div> : filteredBalances?.length === 0 ? <PortfolioEmptyState /> : <div className='relative'>
                {selectedTap === 'holdings' ? <ScrollArea className='h-[524px]'>
                    <div className='overflow-y-auto h-full'>
                      <DTPortfolioAssetsList setLinkClickedLoading={setLinkClickedLoading} isSwap={isSwap} assetData={assetData} balances={filteredBalances} />
                    </div>
                  </ScrollArea> : <ScrollArea className='h-[524px]'>
                    <DesktopHistory />
                  </ScrollArea>}
              </div>}
          </div> : <div className='flex items-center h-full w-full ta-c justiy-center mt-[150px]'>
            <div className='w-full h-full'>
              <Image src='/icons/nothingcircle.png' alt='nothing here' width={100} height={100} className='w-[120px]' />
              <p className='text-genius-cream/50 text-[20px] mt-8'>Nothing Here yet.</p>
            </div>
          </div>}
      </div>
    </>;
}